module.exports = __webpack_public_path__ + "ty5-72dbd8c4.png";